// Convert a date string to Eastern Time
const toEasternTime = (dateString) => {
  const date = new Date(dateString);
  return new Date(date.toLocaleString('en-US', {timeZone: 'America/New_York'}));
};

// Parse ISO string without converting to local timezone
// Extracts date/time components directly from the string
const parseISOWithoutConversion = (isoString) => {
  if (!isoString) return null;
  // Parse: 2025-12-31T20:28:48.510615-08:00
  const match = isoString.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/,
  );
  if (!match) {
    return null;
  }
  const [, year, month, day, hours, minutes, seconds] = match;
  const yearNum = parseInt(year, 10);
  const monthNum = parseInt(month, 10);
  const dayNum = parseInt(day, 10);
  return {
    year: yearNum,
    month: monthNum,
    day: dayNum,
    hours: parseInt(hours, 10),
    minutes: parseInt(minutes, 10),
    seconds: parseInt(seconds, 10),
    // Calculate day of week from date components (0 = Sunday, 6 = Saturday)
    dayOfWeek: new Date(yearNum, monthNum - 1, dayNum).getDay(),
    // Create a Date object using local timezone interpretation of these components
    toDate: function () {
      return new Date(
        this.year,
        this.month - 1,
        this.day,
        this.hours,
        this.minutes,
        this.seconds,
      );
    },
  };
};

export {parseISOWithoutConversion, toEasternTime};
